var map = {
	"./icon-add.svg": 68869,
	"./icon-arrow.svg": 51089,
	"./icon-close.svg": 50829,
	"./icon-copy.svg": 54171,
	"./icon-edit.svg": 47766,
	"./icon-face.svg": 91183,
	"./icon-friends.svg": 96864,
	"./icon-getgems.svg": 45472,
	"./icon-human.svg": 81415,
	"./icon-level-arrow.svg": 89889,
	"./icon-lucky.svg": 80480,
	"./icon-ok-fill.svg": 78831,
	"./icon-ok.svg": 35686,
	"./icon-ok1.svg": 43440,
	"./icon-quit.svg": 24764,
	"./icon-refresh.svg": 82037,
	"./icon-rewards.svg": 84167,
	"./icon-rule.svg": 58085,
	"./icon-telegram.svg": 45810,
	"./icon-tier.svg": 10676,
	"./icon-time.svg": 94375,
	"./icon-tip.svg": 98117,
	"./icon-twitter.svg": 65765,
	"./icon-up.svg": 33442,
	"./icon-upgrade.svg": 31535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;